import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'
import { useTranslation } from 'react-i18next'

const TargetIdPage = () => {
  const { t } = useTranslation()
  const parentBreadcrumbs = [
    { label: t('header.home'), path: '/' },
    { label: t('header.service'), path: '/service' },
    { label: t('header.services.aiMl.title'), path: '/service/ai-ml' },
    { label: t('aiMlOverview.drugDiscovery.title'), path: '/service/ai-ml/drug-discovery' }
  ]
  return (
    <TechnicalServicePage
      serviceKey="targetId"
      translationKey="bioinformatics.categories.targetId"
      parentBreadcrumbs={parentBreadcrumbs}
    />
  )
}

export default TargetIdPage
